module.exports = __webpack_public_path__ + "img/add_information.4d103738.svg";